module.exports = __webpack_public_path__ + "static/media/logoABC.22945948.webp";